module.exports = __webpack_public_path__ + "img/noimg.ff66beba.jpg";